/**
 * Used to parse the flags from the API for row validation
 */
export enum ValidationState {
    duplicate = 1,
    update = 2,
    new = 4,
}
